
import { useState, useEffect } from 'react';

interface WhatsAppSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  productName?: string;
}

export default function WhatsAppSelector({ isOpen, onClose, productName }: WhatsAppSelectorProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 200);
  };

  const contacts = [
    {
      name: 'Asesor Andrés',
      link: `https://wa.me/573209769166?text=${encodeURIComponent(productName ? `Hola, me interesa cotizar: ${productName}` : 'Hola, me interesa conocer más sobre sus servicios de publicidad e impresión')}`
    },
    {
      name: 'Asesor Karen',
      link: `https://wa.me/message/GG6UNVA6HN5UG1`
    }
  ];

  const handleContactClick = (link: string) => {
    window.open(link, '_blank');
    handleClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Overlay */}
      <div 
        className={`absolute inset-0 bg-black/50 transition-opacity duration-200 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        onClick={handleClose}
      ></div>
      
      {/* Modal */}
      <div className={`relative bg-white rounded-2xl shadow-2xl p-6 w-80 max-w-[90vw] transition-all duration-200 ${isVisible ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
        <div className="flex justify-between items-center mb-4 pb-4 border-b border-gray-200">
          <div>
            <h3 className="text-lg font-bold text-gray-900">¿Con quién deseas hablar?</h3>
            {productName && (
              <p className="text-sm text-gray-500 mt-1">Producto: {productName}</p>
            )}
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 cursor-pointer w-8 h-8 flex items-center justify-center"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        
        <div className="flex flex-col gap-3">
          {contacts.map((contact, index) => (
            <button
              key={index}
              onClick={() => handleContactClick(contact.link)}
              className="flex items-center gap-4 p-4 rounded-xl bg-green-50 hover:bg-green-100 transition-all duration-200 cursor-pointer group border border-green-100 hover:border-green-300"
            >
              <div className="bg-green-500 w-12 h-12 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
                <i className="ri-whatsapp-fill text-white text-2xl"></i>
              </div>
              <div className="flex flex-col items-start">
                <span className="text-base font-semibold text-gray-800 whitespace-nowrap">{contact.name}</span>
                <span className="text-sm text-green-600">Disponible ahora</span>
              </div>
              <i className="ri-arrow-right-s-line text-gray-400 ml-auto text-xl"></i>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
